export default __webpack_public_path__ + "static/media/icono-maternidad.ddec6451.svg";